// Client-side defaults for portal settings. Mirrors the server's
// PORTAL_SETTINGS_DEFAULTS (server/services/portal-settings-defaults.js) so the
// app paints meaningful copy immediately, before /api/public-config resolves.
// The server payload (DB-backed, admin-editable) overrides these at runtime.
//
// Keep this in sync with the server defaults. They're intentionally duplicated
// rather than shared because the client bundle must not import server modules.
import { DEFAULT_THEME_PALETTE } from '../theme.js';

export const PORTAL_SETTINGS_DEFAULTS = {
  program_name: 'Alabama Statewide Imagery Program',
  page_title: 'Alabama Statewide Imagery Enhancement Portal',
  meta_description:
    'Explore products, estimate investment, and start a conversation with Sanborn.',
  hero_headline: 'Build a custom aerial imagery package for your community',
  hero_body:
    'Explore high-resolution imagery, LiDAR, and analytics — then get a '
    + 'preliminary investment estimate in minutes, together with communities '
    + 'across Alabama.',
  intake_header_title: 'Statewide Aerial Imagery',
  intake_header_subtitle:
    'Select your project area and products to get a preliminary investment estimate.',
  region_display_name: 'Alabama',
  subdivision_primary: { singular: 'county', plural: 'counties' },
  subdivision_secondary: { singular: 'city', plural: 'cities' },
  population_source_label: 'U.S. Census 2020',
  // Blocked-access page copy. Any contact email is baked into the body text.
  blocked_page_title: 'Let’s connect directly',
  blocked_page_body:
    'We weren’t able to open the self-service package builder for this email '
    + 'address. Our team would be glad to help you put together a proposal for '
    + 'the program.\n\n'
    + 'Please reach out to sales@sanborn.com and we’ll follow up directly.',
  // Confirmation ("thank you") page copy. Any follow-up contact email is baked
  // into the body text by the admin.
  thank_you_title: 'Thank you for your interest',
  thank_you_body:
    'Your inquiry has been received. A Sanborn representative will review your '
    + 'selections and follow up with a formal proposal shortly.\n\n'
    + 'Have a question in the meantime? Reach us directly at sales@sanborn.com.',
  value_props: [
    {
      key: 'economies',
      icon: 'savings',
      title: 'Economies of Scale',
      body: 'Statewide program pricing delivers significant savings for every county.',
    },
    {
      key: 'quality',
      icon: 'verified_user',
      title: 'Consistent Quality',
      body: 'Standardized data collection and accuracy across the whole region.',
    },
    {
      key: 'future',
      icon: 'cloud',
      title: 'Future Ready',
      body: 'Build a comprehensive geospatial foundation for years to come.',
    },
    {
      key: 'local',
      icon: 'groups',
      title: 'Local Control',
      body: 'Communities own their data and decide how it is used.',
    },
    {
      key: 'together',
      icon: 'star',
      title: 'Stronger Together',
      body: 'A statewide approach for a smarter, more connected region.',
    },
  ],
  // Theme palette overrides per mode (admin Branding page). The built-in
  // theme tokens are the canonical defaults; reusing them here keeps the
  // pre-fetch paint identical to a fresh deployment.
  theme_palette: DEFAULT_THEME_PALETTE,
};
